const en = {
  // 通用
  loading: 'loading...',
  language: 'language',
  backHome: 'back homepage',
  backUp: 'Return to the previous page',
  page403: 'Sorry, you do not have any access to the page',
  page404: 'Sorry, the page you visited does not exist',
  page500: 'Sorry, the server had an error',
  noData: 'No data',
  seq: 'Seq',
  status: 'status',
  importSeq: 'Please enter a seq',
  add: 'Add',
  delete: 'delete',
  operate: 'operate',
  edit: 'edit',
  query: 'query',
  date: 'date',
  to: 'to',
  startTime: 'Start time',
  endTime: 'End time',
  keywords: 'keywords',
  importkeys: 'please enter a keywords',
  back: 'back',
  yes: 'yes',
  no: 'no',
  save: 'save',
  cancel: 'cancel',
  enable: 'enable',
  disabled: 'disabled',
  lastweek: 'last week',
  lasmonth: 'last months',
  lasmonth3: 'last three months',
  // 导航栏
  goBackgourd: 'Enter the background',
  sysLogin: 'system login',
  sysManagelogin: 'System management login',
  backManager: 'Safety manage platform -BAM',
  self_platform: 'contractor self-service platform',
  exam_platform: 'Contractor online exam',
  appliaction: 'appliaction',
  trainexam: 'On-line train exam -Mobile ',
  mobile: 'Safety manage platform -Mobile',
  android_app: 'Android APP',

  homeTitle_01: 'Safety management platform',
  homeTitle_011_child: 'Contractor management',
  homeTitle_012_child: 'Safety train',
  homeTitle_013_child: 'Check violation',
  homeTitle_014_child: 'Tool management',
  homeTitle_015_child: 'Vehicle management',
  homeTitle_016_child: 'System management',

  homeTitle_02: 'standardized training exam',
  homeTitle_021_child: 'Book a training',
  homeTitle_022_child: 'Question bank classification',
  homeTitle_023_child: 'Exam paper management',
  homeTitle_024_child: 'face recognition',
  homeTitle_025_child: 'Exam Statistics',
  homeTitle_026_child: 'Mobile training management',

  homeTitle_03: 'Violation inspection',
  homeTitle_031_child: 'Illegal entry',
  homeTitle_032_child: 'Violation audit',
  homeTitle_033_child: 'Illegal management',
  homeTitle_034_child: 'Illegal regulations',
  homeTitle_035_child: 'Incident investigation',
  homeTitle_036_child: 'Illegal Statistics',

  // 登录
  login: 'Login',
  username: 'UserName',
  pwd: 'password',
  savePwd: 'Remember the password ',
  validCode: 'Valid Code',
  upvalidimg: 'Click to switch pictures',
  importUserName: 'Please enter a username',
  importPwd: 'Please enter a Password',
  importPwdErr: 'Your password complexity is too low (must contain text, numbers, special characters, 8-20 characters)!',
  importvalidCode: 'Please enter a ValidCode',
  loginSuccess: 'Login Successfully',

  // 后台首页
  home: ' Home',
  proscenium: 'Return proscenium',
  outlogin: 'Out Login',
  outok: 'Out successfully',

  // 首页 轮播图接口
  picture: 'picture',
  importPic: 'Please enter a picture',
  slideshow: 'slideshow',

  // 首页分类
  menu: ' Menu',
  selectMenu: 'Please select the menu',
  name: 'name',
  Ename: 'English name',
  importName: 'Please enter a name',
  importEName: 'Please enter a English name',
  classify: 'classify',

  // 文件上传控件
  upfileMsg: 'Drag the file here, or',
  upfileMsg2: 'Only jpg / png images can be uploaded and no more than 500kb',
  upfileMsg3: 'Only the jpg / png images can be uploaded',
  upfileMsg4: 'Upload picture size cannot exceed 500kb',
  clickFile: 'Click to upload',

  // 首页内容
  title: 'title',
  importTit: 'please enter a title',
  content: 'content',
  importClass: 'please enter a classify',
  importContent: 'please enter a content',

  // 首页菜单
  path: 'path',
  importPath: 'please enter a path',

  // 日志查询
  logtype: 'Log type',
  selectLogType: 'Please select the log type',
  clientTpe: 'client type',
  selectType: 'Please select the client type',
  logTime: 'logTime',
  opUsername: 'operate userName',
  exception: 'exception',

  // 权限管理
  permissionName: 'Permission name',
  importPermission: 'please enter a permission name',
  interfaceAddress: 'interface address',
  importInterface: 'please enter a interface address',
  remark: 'remark',
  importRemark: 'please enter a remark',
  btnPermission: ' button permissions',

  // 菜单管理
  parentMenu: 'Parent menu',
  selectParentMenu: 'Please select the Parent Menu',
  menuCode: 'menu code',
  importmenuCode: 'please enter a menu Code',
  menuName: 'menu Name',
  importmenuName: 'please enter a menu Name',
  menuType: 'menu type',
  icon: 'icon',
  importicon: 'please enter a icon',
  param: 'parameter',
  importParam: 'please enter a parameter',
  isopen: 'Opens the new window not',
  isShowMenu: 'Does it appear in the sidebar not',
  menuErrMsg: 'The menu encoding length must be between 3 and 100',
  menuErrMsg2: 'The menu name length must be between 2 and 50',

  // 角色管理
  RoleName: 'role name',
  role: 'role',
  importRole: 'please enter a role name',
  roleCode: 'role code',
  importRoleCode: 'please enter a role code',
  Rolekeywords: 'Please enter the role name, the encoding',
  permissionEdit: 'perminssion edit',
  power: 'power',
  checkAll: 'check all',

  // 基地管理
  baseName: 'base name',
  base: 'base',
  importbaseName: 'please enter a role base name',
  shortName: 'base short name',
  importBaseShortName: 'please enter a role base short name',
  baseCode: 'base code',
  importbaseCode: 'please enter a role base code',
  basekeywords: 'Please enter the base name and encode',

  // 用户管理
  usercode: 'user code',
  user: ' user',
  importUserCode: 'please enter a user code',
  position: 'position',
  importposition: 'please enter a position',
  email: 'email',
  importEmail: 'please enter a email',
  emailErrMsg: 'Wrong email format',
  account: 'account',
  importAccount: 'please enter a account',
  isAdmin: 'is admin?',
  phone: 'phone',
  phoneErrMsg: 'The mobile phone is misformed',
  importPhone: 'please enter a phone',
  userkeywords: 'Please enter the user name,account,user number,phone number',
  oldPassword: 'old password',
  importOldPwd: 'please enter a old password',
  newPwd: 'new password',
  importNewPwd: 'please enter a new password',
  confirmPwd: 'confirm password',
  confirmAgain: 'fill in the confirmation again',
  updatePwd: 'change password',
  pwdNotEqual: 'The password is inconsistent twice'
};
export default en;
